import { SAGA_ACTIONS } from "src/_config";
import { useApiCall } from "../common/appApiCallHook";

export function useJobPostingApi() {
  const callApi = useApiCall();

  const createJob = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.JOB_POSTING.CREATE_JOB, data, onSuccess, onError);
  };

  const updateJob = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.JOB_POSTING.UPDATE_JOB, data, onSuccess, onError);
  };

  const getJobDetails = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.JOB.GET_JOB_DETAILS, data, onSuccess, onError);
  };

  return {
    callCreateJob: createJob,
    callUpdateJob: updateJob,
    callGetJobDetails: getJobDetails,
  };
}
